<template>
	<v-row class="section-time px-4 py-6 primary--text">
		<v-col md="3" sm="12">
			<span class="text-h4">Время работы ярмарки</span>
		</v-col>
		<v-col md="9" sm="12">
			<div>Понедельник-четверг: 11:00 - 22:00</div>
			<div>Пятница: 11:00 - 23:00</div>
			<div>Суббота, воскресенье, праздничные дни: 10:00 - 23:00</div>
		</v-col>
	</v-row>
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
	name: 'SectionTime',
});
</script>
